import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { EncriptyUtilService } from '../../shared/services/encripty-util.service';
import { AlterarSenhaService } from './alterar-senha.service';
import { NgxSpinnerService } from "ngx-spinner";
import Base64 from '../../shared/utils/Base64';
import { debounceTime } from 'rxjs/operators';
import { AuthenticationService } from '../../shared/services/authentication.service';

interface IAlterPasswordFormProps {
  newPassword: string;
  repetirSenha: string;
}

@Component({
  selector: 'ngx-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.css', './alterar-senha.component.scss']
})
export class AlterarSenhaComponent implements OnInit, OnDestroy {

  novaSenhaForm: FormGroup;
  public customLogin = null;
  user = [];
  email = [];
  urlClient = null;
  novaSenha = null;
  passLength = false;
  passEquals = false;
  passSpecialChar = false;
  passLowerCase = false;
  passUpperCase = false;
  passNumber = false;
  passSequence = false;
  passName = false;
  showPass = false;
  showRepeatPass = false;
  showSuccess = false;
  regexSpecialChar = /^([^@!#$%^&*()_+{}\[\]:;<>,.?~\\|/]*[@!#$%^&*()_+{}\[\]:;<>,.?~\\|/]){1,3}[^@!#$%^&*()_+{}\[\]:;<>,.?~\\|/]*$/


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private notifications: NotificationsService,
    private encriptyService: EncriptyUtilService,
    private alterarSenhaService: AlterarSenhaService,
    private spinnerService: NgxSpinnerService,
    private authenticationService: AuthenticationService,
  ) {

  }

  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    //let login = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-user'));
    const jsonUser = this.getUserByToken();
    this.urlClient = localStorage.getItem('bway-url')
    this.alterarSenhaService.getUserData({
      dominio: 'PORTAL',
      login: jsonUser.login,
    }).toPromise().then((response) => {
      this.user = Base64.decode(response['nome']).toLowerCase().split(' ');
      this.email = Base64.decode(response['email']).toLowerCase().split('@');


      this.createFormNovaSenha()
    }).catch((error) => {
      this.notifications.error(error ? error.error : 'Serviço indisponível');
      this.spinnerService.hide();
    })

  }

  ngOnDestroy(): void {
    this.novaSenhaForm = null;
  }

  createFormNovaSenha() {
    this.novaSenhaForm = this.formBuilder.group({
      newPassword: [],
      repetirSenha: [],
    });

    this.novaSenhaForm
      .get("newPassword")
      .valueChanges.subscribe((value: string) => {
        const valueRepetir = this.novaSenhaForm.get("repetirSenha").value
        this.passLength = !!(value && value.length >= 8 && value.length <= 16);

        if (value && value.match(/[^A-z\s\d][\\\^]?/g)) {
          this.passSpecialChar = true;
        } else {
          this.passSpecialChar = false;
        }

        if (value && (/[A-Z]/.test(value) && /[a-z]/.test(value))) {
          this.passUpperCase = true;
        } else {
          this.passUpperCase = false;
        }

        if (value && value.match(/[A-Za-z][\\\^]?/g)) {
          this.passLowerCase = true;
        } else {
          this.passLowerCase = false;
        }

        if (value && value.match(/[0-9][\\\^]?/g)) {
          this.passNumber = true;
        } else {
          this.passNumber = false;
        }

        if (value) {
          let numberAsc = /123|1234|12345|123456|12345678/g.test(value)
          let numberRepeat = /(?=.*([1-9]+)\1{1,}).*$/g.test(value)
          let letterSequence = /(?=.*([a-zA-Z]+)\1{1,}).*$/g.test(value)
          let strSequeceAbcd = /abcd|qwe|abc|abcde/i.test(value)
          

          if (numberAsc || numberRepeat || letterSequence || strSequeceAbcd) {
            this.passSequence = false;
          } else {
            this.passSequence = true;
          }
        } else {
          this.passSequence = false;
        }

        if (value) {
          const lowercaseValue = value.toLowerCase();
          const userMatch = this.user.some(user => lowercaseValue.includes(user));
          const emailMatch = this.email.some(email => lowercaseValue.includes(email));

          if (userMatch || emailMatch) {
            this.passName = false;
          } else {
            this.passName = true;
          }
        } else {
          this.passName = false;
        }

        this.novaSenha = value;
      })

      this.novaSenhaForm
      .get("repetirSenha")
      .valueChanges.pipe(debounceTime(500)).subscribe((value: string) => {
        if (value && value.length > 7) {
          if (value !== this.novaSenha) {
            this.novaSenhaForm
              .get("repetirSenha").setErrors([{
                'true': true
              }])
            this.novaSenhaForm.controls['repetirSenha'].markAsTouched()
            this.passEquals = false
          } else {
            this.passEquals = true
          }
        } else {
          this.passEquals = false
        }
      });
  }


  toggleShowPass() {
    this.showPass = !this.showPass;
  }

  toggleShowRepeatPass() {
    this.showRepeatPass = !this.showRepeatPass;
  }

  sendNewPassword() {
    const values = this.novaSenhaForm.getRawValue() as IAlterPasswordFormProps;
    if (values.newPassword) {
      if (values.repetirSenha) {
        if (this.passLength && this.passNumber && this.passSpecialChar
          && this.passName && this.passSequence && this.passEquals && this.passUpperCase) {
          this.spinnerService.show();
          this.alterarSenhaService.changePassword({
            newPassword: Base64.encode(values.newPassword),
            urlClient: this.urlClient
          },(response) => {
            this.spinnerService.hide();
            this.showSuccess = true;
          },(error) => {
            this.spinnerService.hide();
            if (error) {
              let e = error.message || error.mensagem
              this.notifications.error(e || '');
            }
            this.spinnerService.hide();
          })
        } else {
          this.notifications.error(
            "A senha não atende os requisitos! Por favor verifique."
          );
        }
      } else {
        this.notifications.error("As senhas não conferem!");
      }
    } else {
      this.notifications.error(`O campo 'Repetir nova senha' deve ser preenchido`);
    }
  }

  goBack() {
    this.ngOnDestroy()
    this.router.navigate(['/iot-dashboard']);
  }

  goToAccount() {
    this.spinnerService.show();
    this.authenticationService.doLogout();
    this.spinnerService.hide();
    this.notifications.error('Login expirado.');
  }

  getHeaderLogo() {
    return this.customLogin && this.customLogin.headerMenu ? 'url(data:image/png;base64,' + this.customLogin.headerMenu + ') no-repeat left/cover' : './../images/'
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getUserByToken() {
    const [p1, p2, p3] = localStorage.getItem('bway-token').toString().split('.');
    const [v1, v2, v3, v4, v5] = Base64.decode(p2).toString().split(';');
    return JSON.parse(v1);
  }

  getHome() {
    if (this.customLogin != null) {
      return this.customLogin.home;
    }
  }

}
